import { useEffect, useRef, useState } from "react";
import { Sparkles, Loader2 } from "lucide-react";
import { api } from "../lib/api";

// Cache em memória para não repetir chamadas na mesma sessão
const cache = new Map();

export function useJobAiSummary(slug) {
  const [state, setState] = useState({ loading: false, bullets: cache.get(slug) || null });
  const timerRef = useRef(null);
  const abortRef = useRef(false);

  const request = () => {
    if (cache.has(slug)) {
      setState({ loading: false, bullets: cache.get(slug) });
      return;
    }
    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(async () => {
      setState({ loading: true, bullets: null });
      abortRef.current = false;
      try {
        const r = await api.get(`/jobs/${slug}/summary`);
        if (abortRef.current) return;
        const bullets = r.data?.summary || [];
        cache.set(slug, bullets);
        setState({ loading: false, bullets });
      } catch {
        if (abortRef.current) return;
        setState({ loading: false, bullets: [] });
      }
    }, 300);
  };

  const cancel = () => {
    clearTimeout(timerRef.current);
    abortRef.current = true;
  };

  useEffect(() => () => cancel(), []);
  return { ...state, request, cancel };
}

export function JobAiPreviewCard({ loading, bullets, isGold }) {
  if (!loading && (!bullets || bullets.length === 0)) return null;
  return (
    <div
      className={`pointer-events-none absolute left-2 right-2 top-full mt-2 z-40 rounded-xl border shadow-xl p-3 ${
        isGold ? "bg-slate-950/95 border-amber-400/40 text-amber-50" : "bg-white border-slate-200 text-slate-700"
      }`}
    >
      <div className="flex items-center gap-1.5 mb-1.5">
        <Sparkles className={`w-3 h-3 ${isGold ? "text-amber-300" : "text-amber-500"}`} />
        <span className="text-[10px] uppercase tracking-widest font-bold">Resumo IA</span>
        {loading && <Loader2 className="w-3 h-3 animate-spin ml-1" />}
      </div>
      {loading ? (
        <div className="space-y-1.5">
          <div className={`h-2.5 rounded ${isGold ? "bg-white/10" : "bg-slate-100"} animate-pulse`} />
          <div className={`h-2.5 rounded w-4/5 ${isGold ? "bg-white/10" : "bg-slate-100"} animate-pulse`} />
          <div className={`h-2.5 rounded w-3/4 ${isGold ? "bg-white/10" : "bg-slate-100"} animate-pulse`} />
        </div>
      ) : (
        <ul className="space-y-1 text-xs leading-relaxed">
          {bullets.map((b, i) => (
            <li key={i} className="flex gap-1.5">
              <span className={`shrink-0 ${isGold ? "text-amber-300" : "text-amber-500"}`}>•</span>
              <span>{b}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
